(() => {
  if (window.THBModalScroll) return;
  const owners = new Set();
  let restore;
  window.THBModalScroll = {
    lock(owner) {
      if (owners.has(owner)) return;
      if (!owners.size) {
        const body = document.body, html = document.documentElement;
        const wrapper = document.querySelector('.page-wrapper');
        const x = window.scrollX, y = window.scrollY;
        const targets = [[body, ['position', 'top', 'left', 'width', 'overflow']], [html, ['overflow', 'scroll-behavior']]];
        if (wrapper) targets.push([wrapper, ['overflow', 'scroll-behavior']]);
        const saved = targets.map(([el, keys]) => ({el, top: el.scrollTop, left: el.scrollLeft, styles: keys.map(key => [key, el.style.getPropertyValue(key), el.style.getPropertyPriority(key)])}));
        body.style.position = 'fixed'; body.style.top = -y + 'px'; body.style.left = -x + 'px'; body.style.width = '100%'; body.style.overflow = 'hidden';
        html.style.overflow = 'hidden'; html.style.scrollBehavior = 'auto';
        if (wrapper) { wrapper.style.overflow = 'hidden'; wrapper.style.scrollBehavior = 'auto'; }
        restore = () => {
          saved.forEach(({el, styles}) => styles.forEach(([key, value, priority]) => value ? el.style.setProperty(key, value, priority) : el.style.removeProperty(key)));
          saved.forEach(({el, top, left}) => { if (el !== html && el !== body) el.scrollTo({top, left, behavior: 'instant'}); });
          window.scrollTo({top: y, left: x, behavior: 'instant'});
        };
      }
      owners.add(owner);
    },
    unlock(owner) {
      if (!owners.delete(owner) || owners.size) return;
      restore?.(); restore = null;
    }
  };
})();
